import React, { Component } from 'react';
import { connect } from 'react-redux';
import AdminView from './AdminView';
import DoctorView from './DoctorView';

class DoctorAttendanceDashboard extends Component {
  componentDidMount() {
    if (!this.props.authToken) {
      this.props.history.push('/');
    }
  }

  render() {
    const { authToken, attendanceAdmin } = this.props;
    if (!authToken) return null;
    console.log('[AttendanceDashboard] attendanceAdmin =', attendanceAdmin);
    if (attendanceAdmin) return <AdminView {...this.props} />;
    return <DoctorView {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  authToken:       state.user.authToken,
  doctorId:        state.user.doctorId,
  doctorFirstName: state.user.doctorFirstName,
  insurer:         state.user.insurer,
  qc:              state.user.qc,
  admin:           state.user.admin,
  attendanceAdmin: state.user.attendanceAdmin,
});

export default connect(mapStateToProps)(DoctorAttendanceDashboard);
